/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CancelAction from './CancelAction/index'
import ContactMethod from './ContactMethod/index'
import ContactMethodType from './ContactMethodType/index'
import DateOfBirth from './DateOfBirth/index'
import HorizontalDivider from 'DesignSystem/HorizontalDivider/index'
import Qr from './Qr/index'
import React from 'react'
import Sidebar from './Sidebar/index'
import SubmitAction from './SubmitAction/index'
import TysiaModal from 'DesignSystem/TysiaModal/index'
import TysiaModalContent from 'DesignSystem/TysiaModal/TysiaModalContent/index'
import TysiaModalHeader from 'DesignSystem/TysiaModal/TysiaModalHeader/index'
import TysiaModalHeaderCloseAction from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderCloseAction/index'
import TysiaModalHeaderTitle from 'DesignSystem/TysiaModal/TysiaModalHeader/TysiaModalHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Url from './Url/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content/Send/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 width={720}
 minHeight={640}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
>
{childProps => (
<React.Fragment>
<TysiaModalHeader
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeader`}
>
{childProps => (
<React.Fragment>
<TysiaModalHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderTitle`}
 text="Send case closer request"
/>
<TysiaModalHeaderCloseAction
{...childProps}
  viewPath={`${viewPath}/TysiaModalHeaderCloseAction`}
/>
</React.Fragment>
)}
</TysiaModalHeader>
<TysiaModalContent
{...childProps}
  viewPath={`${viewPath}/TysiaModalContent`}
 paddingTop={0}
 paddingBottom={0}
 paddingLeft={0}
 paddingRight={0}
 gap={dtSpaceS}
>
{childProps => (
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--brc-1-Z1Yf8zk': dtColorsNeutral200,'--pt-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-5-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-6-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="Send the treatment plan to the payor for signing."
/>
<ContactMethodType
  viewPath={`${viewPath}/ContactMethodType`}
/>
<ContactMethod
  viewPath={`${viewPath}/ContactMethod`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="The payor will receive an email with the link to the treatment plan."
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 width="45%"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="or"
/>
<HorizontalDivider
  viewPath={`${viewPath}/HorizontalDivider`}
 width="45%"
/>
</div>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 text="Use a link and code to access and sign the document. Works best when the signatory is in the clinic."
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--bc-7-Z1Yf8zk': dtColorsWhite,'--pt-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-5-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btc-8-Z1Yf8zk': dtColorsNeutral200,'--bbc-9-Z1Yf8zk': dtColorsNeutral200,'--blc-10-Z1Yf8zk': dtColorsNeutral200,'--brc-1-Z1Yf8zk': dtColorsNeutral200,'--bblr-11-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btlr-12-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bbrr-13-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--btrr-14-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical2}`}
>
<Url
  viewPath={`${viewPath}/Url`}
/>
<DateOfBirth
  viewPath={`${viewPath}/DateOfBirth`}
/>
</div>
<Qr
  viewPath={`${viewPath}/Qr`}
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<CancelAction
  viewPath={`${viewPath}/CancelAction`}
/>
<SubmitAction
  viewPath={`${viewPath}/SubmitAction`}
/>
</div>
</div>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--bc-7-Z1Yf8zk': dtColorsWhite}}
 className={`views-block ${styles.Vertical3}`}
>
<Sidebar
  viewPath={`${viewPath}/Sidebar`}
/>
</div>
</div>
)}
</TysiaModalContent>
</React.Fragment>
)}
</TysiaModal>
{children}
</React.Fragment>)
}